import { lazy } from "@bridgesplit/ui";

import LendDialog from "./LendDialog";
import BorrowDialog from "./BorrowDialog";
import MarketGuideDialog from "./guide/MarketGuideDialog";
import UpdateApyAndCollateralDialog from "./UpdateApyAndCollateralDialog";

const MarketDetail = lazy(() => import("./MarketDetail"));

export { MarketDetail, LendDialog, MarketGuideDialog, BorrowDialog, UpdateApyAndCollateralDialog };

export * from "./dialog";
export * from "./borrow";
